import { checkPagePermission, checkLoginPermission } from './page.js';

/**
 * 权限校验数组，排在最前面的优先级越高，若符中前面的一个后面的将会不再做检测
 */
const CHECK_ARR = [
    {
        'key': 'checkPage',
        'handler': checkPagePermission // 框架级页面权限校验
    }
]



async function checkPlatformPermission(curRoute) {
    // 判断是否是白名单
    await checkLoginPermission(curRoute);
    let meta = curRoute.meta || {};
    let len = CHECK_ARR.length;
    let isBreak = false;
    for(let i = 0; i < len; i++) {
        let item = CHECK_ARR[i];
        let key = item.key;
        if(meta[key]) {
            await item.handler.call(this, curRoute).then(data => {
                isBreak = data
            })
            if (!isBreak) {
                break;
            }
        }
    }
}

export {
    checkPlatformPermission
};
